












import Vue, {PropOptions} from "vue";

export default Vue.extend({
  name: 'BaseLayoutModifier',
  props: {
    tag: {
      type: String,
      default: 'button',
      description: 'The HTML tag of the component (button, a)',
    } as PropOptions<string>,
    size: {
      type: String,
      description: 'Button size (sm, lg)',
    } as PropOptions<string>,
    variant: {
      type: String,
      default: 'primary',
      description: 'Button variant (primary, alt-primary, outline-primary, secondary, alt-secondary, outline-secondary, light, alt-light, outline-light, dark, alt-dark, outline-dark, danger, alt-danger, outline-danger, info, alt-info, outline-info, success, alt-success, outline-success, warning, alt-warning, outline-warning, dual)',
    } as PropOptions<string>,
    action: {
      type: String,
      description: 'Specify the layout modifier mode to apply on click',
    } as PropOptions<string>,
  },
  computed: {
    classContainer () {
      return {
        [`btn btn-${this.variant}`]: this.tag === 'button' && this.variant,
        [`btn-${this.size}`]: this.tag === 'button' && this.size,
      };
    },
  },
  methods: {
    layout (action: string) {
      // Set up layout API
      const layoutAPI = {
        sidebarOpen: () => this.$store.commit('sidebar', { mode: 'open' }),
        sidebarClose: () => this.$store.commit('sidebar', { mode: 'close' }),
        sidebarToggle: () => this.$store.commit('sidebar', { mode: 'toggle' }),
        sidebarPositionLeft: () => this.$store.commit('sidebarPosition', { mode: 'left' }),
        sidebarPositionRight: () => this.$store.commit('sidebarPosition', { mode: 'right' }),
        sidebarPositionToggle: () => this.$store.commit('sidebarPosition', { mode: 'toggle' }),
        sidebarStyleDark: () => this.$store.commit('sidebarStyle', { mode: 'dark' }),
        sidebarStyleLight: () => this.$store.commit('sidebarStyle', { mode: 'light' }),
        sidebarStyleToggle: () => this.$store.commit('sidebarStyle', { mode: 'toggle' }),
        sidebarMiniOn: () => this.$store.commit('sidebarMini', { mode: 'on' }),
        sidebarMiniOff: () => this.$store.commit('sidebarMini', { mode: 'off' }),
        sidebarMiniToggle: () => this.$store.commit('sidebarMini', { mode: 'toggle' }),
        sideOverlayOpen: () => this.$store.commit('sideOverlay', { mode: 'open' }),
        sideOverlayClose: () => this.$store.commit('sideOverlay', { mode: 'close' }),
        sideOverlayToggle: () => this.$store.commit('sideOverlay', { mode: 'toggle' }),
        sideOverlayHoverOn: () => this.$store.commit('sideOverlayHover', { mode: 'on' }),
        sideOverlayHoverOff: () => this.$store.commit('sideOverlayHover', { mode: 'off' }),
        sideOverlayHoverToggle: () => this.$store.commit('sideOverlayHover', { mode: 'toggle' }),
        headerFixed: () => this.$store.commit('header', { mode: 'fixed' }),
        headerStatic: () => this.$store.commit('header', { mode: 'static' }),
        headerToggle: () => this.$store.commit('header', { mode: 'toggle' }),
        headerStyleDark: () => this.$store.commit('headerStyle', { mode: 'dark' }),
        headerStyleLight: () => this.$store.commit('headerStyle', { mode: 'light' }),
        headerStyleToggle: () => this.$store.commit('headerStyle', { mode: 'toggle' }),
        headerSearchOn: () => this.$store.commit('headerSearch', { mode: 'on' }),
        headerSearchOff: () => this.$store.commit('headerSearch', { mode: 'off' }),
        headerSearchToggle: () => this.$store.commit('headerSearch', { mode: 'toggle' }),
        headerLoaderOn: () => this.$store.commit('headerLoader', { mode: 'on' }),
        headerLoaderOff: () => this.$store.commit('headerLoader', { mode: 'off' }),
        headerLoaderToggle: () => this.$store.commit('headerLoader', { mode: 'toggle' }),
        pageLoaderOn: () => this.$store.commit('pageLoader', { mode: 'on' }),
        pageLoaderOff: () => this.$store.commit('pageLoader', { mode: 'off' }),
        pageLoaderToggle: () => this.$store.commit('pageLoader', { mode: 'toggle' }),
        mainContentFull: () => this.$store.commit('mainContent', { mode: 'full' }),
        mainContentBoxed: () => this.$store.commit('mainContent', { mode: 'boxed' }),
        mainContentNarrow: () => this.$store.commit('mainContent', { mode: 'narrow' }),
      } as Record<string, () => void>;

      // Call layout API if action is valid
      if (layoutAPI[action]) {
        layoutAPI[action]();
      }
    },
  },
});
